import { SUBSCRIPTION_RECEIVED } from './types'

export default function subscription(state = {}, action = {}){
  switch (action.type) {
    case SUBSCRIPTION_RECEIVED:
      return action.data
    default:
      return state;
  }
}
